import { Typography } from "antd";
import { PageModel } from "survey-core";
import { theme } from "antd";
import { createStyles } from "antd-style";
import { LicensePlate } from "@rumbledirect/ui";

const useStyles = createStyles(({ css }) => ({
  sidebarWrapper: css`
      width: 100%;
      max-width: 250px;
      align-self: flex-start;
      top: 0;
      max-height: calc(100vh - 48px);
      overflow-y: auto;

      @media (min-width: 992px) {
        max-width: 300px;
      }

      @media (max-width: 768px) {
        display: none;
      }
  `,
}));

export const Sidebar = (props: any) => {
  const { useToken } = theme;
  const { token } = useToken();
  const { styles } = useStyles();

  const activePageName = props.survey.activePage?.name;
  const pages = props.survey.pages;

  return (
    <aside className={styles.sidebarWrapper}>
      <div
        style={{
          backgroundColor: token.colorPrimary,
          color: token.colorTextLightSolid ?? "#fff",
          padding: "16px 30px",
          borderRadius: `${token.borderRadiusLG}px ${token.borderRadiusLG}px 0 0`,
        }}
      >
        <Typography.Title
          level={4}
          style={{
            margin: 0,
            color: token.colorTextLightSolid ?? "#fff",
            fontWeight: "700",
          }}
        >
          Mijn overzicht
        </Typography.Title>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          border: `1px solid ${token?.colorBorderSecondary ?? "#d8d8d8"}`,
          padding: "20px 30px",
          borderRadius: `0 0 ${token.borderRadiusLG}px ${token.borderRadiusLG}px`,
          borderTop: "none",
          backgroundColor: "#fff",
        }}
      >
        {props.survey.getValue("licensePlate") && (
          <div style={{ marginBottom: "8px" }}>
            <LicensePlate
              country={props.survey.getValue("licensePlate").country}
            >
              {props.survey.getValue("licensePlate").identifier}
            </LicensePlate>
          </div>
        )}
        {pages
          .filter((page: PageModel) => !page.isStartPage && page.title)
          .map((page: PageModel, index: number) => {
            const isActive = page.name === activePageName;

            return (
              <div key={page.id || page.name}>
                <div style={{ flex: 1 }}>
                  <Typography.Title
                    level={5}
                    style={{
                      margin: 0,
                      color: isActive ? token.colorPrimary : "#d8d8d8",
                      textDecorationLine: page.isVisible ? "" : "line-through",
                      textDecorationColor: token.colorPrimary,
                      textDecorationThickness: ".1em",
                    }}
                  >
                    {page.title || page.name}
                  </Typography.Title>
                </div>
              </div>
            );
          })}
      </div>
    </aside>
  );
};
